export class FavouriteVacancyDeleteHandler {
    resolve = null;
    reject = null;
    popup = null;

    constructor(popup) {
        this.popup = popup;
        this.handleConfirmationSubmit = this.handleConfirmationSubmit.bind(this);
    }

    removeFromFavourites(deleteUri) {
        return new Promise(async (resolve, reject) => {
            this.resolve = resolve;
            this.reject = reject;

            try {
                const response = await fetch(deleteUri);

                this.popup.setContent(await response.text());
                this.popup.getElement().addEventListener('submit', this.handleConfirmationSubmit);
                this.popup.open();
            } catch (error) {
                this.fail(error);
            }
        });
    }

    async confirmRemove(form) {
        try {
            await fetch(form.action);

            this.finish(true);
        } catch (error) {
            this.fail(error);
        }
    }

    async handleConfirmationSubmit(e) {
        e.preventDefault();
        const success = await this.confirmRemove(e.target);
        this.finish(success);
    }

    finish(success) {
        this.resolve(success);
        this.removeEventListeners();
        this.popup.close();
    }

    fail(error) {
        this.reject(error);
        this.removeEventListeners();
        this.popup.close();
    }

    removeEventListeners() {
        this.popup.getElement().removeEventListener('submit', this.handleConfirmationSubmit);
    }
}
